import { initRozcestnikUdaje } from './rozcestnikUdajeService';
import { initRozcestnikZapisy } from './rozcestnikZapisyService';
import { renderLoginComponent } from '../../components/Login';
import karty from "../../content/rozcestnik/karty";
import { scrollToAnchorIfPresent } from '../../utils/common.mjs';

export function initRozcestnik(isPublic) {

    innerInit(isPublic);

    setTimeout(() => {

        const situaceTab = document.getElementsByClassName('gov-tabs__btn');
        const url = new URL(window.location);

        if (situaceTab.length > 0) {
            situaceTab[0].addEventListener("click", event => {
                event.preventDefault();
                url.searchParams.set('userData', 'zivotnisituace');
                window.history.pushState({}, '', url.toString().split('#')[0]);
                innerInit(isPublic); // if user wants to reset the tab
            });

            situaceTab[1].addEventListener("click", event => {
                event.preventDefault();
                url.searchParams.set('userData', 'sluzby');
                window.history.pushState({}, '', url.toString().split('#')[0]);
            });

            situaceTab[2].addEventListener("click", event => {
                event.preventDefault();
                url.searchParams.set('userData', 'mujkatastr');
                window.history.pushState({}, '', url.toString().split('#')[0]);
            });

            situaceTab[3].addEventListener("click", event => {
                event.preventDefault();
                url.searchParams.set('userData', 'oportalu');
                window.history.pushState({}, '', url.toString().split('#')[0]);
            });    
        }       
        scrollToAnchorIfPresent();

    }, 500);

}

function innerInit(isPublic) {
    
    let tilesDiv = document.getElementById('tiles');
    if (tilesDiv) {
      tilesDiv.innerHTML = "";
      tilesDiv.appendChild(karty());

      let rozcestnikUdajeTile = document.getElementById("rozcestnikUdajeTile");
      rozcestnikUdajeTile.addEventListener("click", (event) => {
        event.preventDefault();
        initRozcestnikUdaje(isPublic);
      });

      let rozcestnikZapisyTile = document.getElementById(
        "rozcestnikZapisyTile"
      );
      rozcestnikZapisyTile.addEventListener("click", (event) => {
        event.preventDefault();
        initRozcestnikZapisy(isPublic);
      });

      const loginButton = document.getElementById("loginButton");
      loginButton.addEventListener("gov-click", (event) =>
        renderLoginComponent(null, event)
      );
    }
    // IF LOGGED-IN HIDE THE INVITATION PANEL    
    console.log("isPublic: " + isPublic);
    if (!isPublic) {
        const logininvitation = document.getElementById('logininvitation');
        console.log("logininvitation: " + logininvitation)
        logininvitation.style.display = 'none';
    }
    
}

export function callToast(service) {
    var toastcode = '<gov-toast variant="error" type="solid" gravity="bottom" position="center" time="3000" wcag-close-label="Close message">Služba "' + service + '" není definována.</gov-toast>';
    document.getElementById("toast").innerHTML = toastcode;
}